var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auction-dialog',{attrs:{"title":"응찰기록보기"},on:{"open":_vm.init,"close":_vm.destroy},scopedSlots:_vm._u([{key:"activator",fn:function({attrs,on}){return [_vm._t("activator",null,null,{ attrs, on })]}},{key:"default",fn:function(){return [_c('auction-bids-data',{ref:"bids-data",attrs:{"bids":_vm.bids}})]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }